export default __webpack_public_path__ + "static/media/store_main_banner.50bc7624.jpg";